/* eslint-disable react-refresh/only-export-components */
// Adapted from shadcn/ui's Radix Popover registry:
// https://ui.shadcn.com/r/styles/new-york/popover.json
// Ark supplies the shared material/motion CSS instead of Tailwind utilities.
import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";

import { LiquidGlass } from "./LiquidGlass";
import "./Motion.css";
import "./ShadcnPopover.css";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export function PopoverContent({
  className = "",
  align = "center",
  sideOffset = 8,
  collisionPadding = 12,
  container,
  children,
  asChild = false,
  ...props
}: ComponentProps<typeof PopoverPrimitive.Content> & {
  container?: HTMLElement;
}) {
  return (
    <PopoverPrimitive.Portal {...(container ? { container } : {})}>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        {...props}
        asChild
        className={`ark-glass ark-popover-content ${className}`}
        data-slot="popover-content"
      >
        {asChild ? children : <LiquidGlass>{children}</LiquidGlass>}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
